import script from "./Use.vue?vue&type=script&lang=ts"
export * from "./Use.vue?vue&type=script&lang=ts"

export default script